import websocket from '@/utils/base/socket';
import { Toast } from '@/utils';
import { findDepartMentLeader } from './serve';
import {
    personTs,
    infoTs,
} from '@/views/departmentalRequirements/servestd';

import store from '@/store';

const ROUTEPATH = {
    "市场部": "/rddepartmentalrequirements",
    "研发中心": "/rddepartmentalrequirements",
    "销售部": "/saledepartmentalrequirements"
};

// 处理消息提示
export const useToast = (person: personTs, info: infoTs) => {
    const { toUserId, userId } = person;
    const { text, query, path } = info;
    if (!toUserId || !userId) return Toast('warning', '通知发送失败', 3);

    websocket.Send({
        content: text,
        query: JSON.stringify(query),
        route: path,
        messageSort: '部门需求',
        toUserId,
        type: 0,
        userId,
    });
};


/**
 * 发送消息提示
 */
export const sendMessage = (type, formState) => {
    const person = {
        userId: null,
        toUserId: null,
    };

    const info = {
        text: null,
        query: {
            demander: null,
            firstLevelDepartment: null,
            search: null,
            executor: null,
        },
        path: null,
    };

    const {
        demander,
        requirementName,
        demanderId,
        demanderDept,
        completeRequirementDept,
        executorId,
        executor,
        isReceive,
        requirementDeliveryConfirmation
    } = formState;
    // 接收通知为需求人
    const receiveDemander = () => {
        person.toUserId = demanderId;
    };
    // 接收通知需求部门领导人
    const receiveRequirementLeader = () => {
        const leader = findDepartMentLeader(demanderDept);
        person.toUserId = leader.id;
    };
    // 接收通知完成部门领导人
    const receiveCompleteLeader = () => {
        const leader = findDepartMentLeader(completeRequirementDept);
        person.toUserId = leader.id;
    };
    // 接收通知为任务执行人
    const receiveExecutor = () => {
        person.toUserId = executorId;
    };
    // 发送通知为当前用户
    const sendByUser = () => {
        person.userId = (store.state as any).user.user.id;
    };
    // 发送通知为需求人
    const sendByDemander = () => {
        person.userId = demanderId;
    };
    // 发送通知人为需求部门领导人
    const sendByRequirmentLeader = () => {
        const leader = findDepartMentLeader(demanderDept);
        person.userId = leader.id;
    };
    // 发送通知人为完成部门领导人
    const sendByCompleteLeader = () => {
        const leader = findDepartMentLeader(completeRequirementDept);
        person.userId = leader.id;
    };
    // 发送通知人为任务执行人
    const sendByExecutor = () => {
        person.userId = executorId;
    };
    // 设置发起需求请求参数
    const setRequireQuery = () => {
        info.query.demander = demander;
        info.query.firstLevelDepartment = demanderDept;
        info.query.executor = executor;
        info.query.search = requirementName;
        info.path = ROUTEPATH[demanderDept];
    };
    // 设置接收需求请求参数
    const setCompleteQuery = () => {
        info.query.demander = demander;
        info.query.executor = executor;
        info.query.search = requirementName;
        info.path = ROUTEPATH[completeRequirementDept];
    };
    // 审核请求
    const setDemand = () => {
        const leader = findDepartMentLeader(demanderDept);
        if (!leader) return;
        // 发送通知为需求人
        sendByDemander();
        // 接收通知需求部门领导人
        receiveRequirementLeader()
        // 设置发起需求请求参数
        setRequireQuery();
        // 发送通知
        useToast(person, info);
    };
    // 修改通知
    const handleUpdate = () => {
        info.text = `${(store.state as any).user.user.nickName}修改跨部门需求${requirementName}`
        // 发送通知为当前用户
        sendByUser();
        let isRequireLeader = false;
        const requireLeader = findDepartMentLeader(demanderDept);
        if (requireLeader) {
            isRequireLeader = true;
        }

        if (isRequireLeader && demanderId != requireLeader.id) {
            receiveDemander();
            setRequireQuery();
            useToast(person, info);
        }

        if (demanderDept && !isRequireLeader) {
            receiveRequirementLeader();
            setRequireQuery();
            useToast(person, info);
        }
        if (completeRequirementDept && executorId) {
            receiveCompleteLeader();
            setCompleteQuery();
            useToast(person, info);
        }
        if (executorId) {
            receiveExecutor();
            setCompleteQuery();
            useToast(person, info);
        }
    };
    // 审核过了通完成需求部门
    const setExamine = () => {
        // 发送通知人为需求部门领导人
        sendByRequirmentLeader();
        // 接收通知完成部门领导人
        receiveCompleteLeader();
        // 设置接收需求请求参数
        setCompleteQuery();
        // 发送通知
        useToast(person, info);
    };

    // 接收需求通知部门领导人
    const setReceive = () => {
        // 发送通知人为完成部门领导人
        sendByCompleteLeader();
        // 接收通知需求部门领导人
        receiveRequirementLeader();
        // 设置发起需求请求参数
        setRequireQuery();
        // 发送通知
        useToast(person, info);
    };

    // 执行人更换
    const setExcutor = () => {
        info.text = `跨部门需求${requirementName}需处理`;
        // 发送通知为当前用户
        sendByUser();
        // 接收通知为任务执行人
        receiveExecutor();
        // 设置接收需求请求参数
        setCompleteQuery();
        // 发送通知
        useToast(person, info);
    };

    // 需求接收处理
    const handleRecive = () => {
        // 接收需求
        if (isReceive) {
            info.text = `跨部门需求${requirementName}需处理`;
            if (!executor) return;
            // 发送通知人为完成部门领导人
            sendByCompleteLeader();
            // 接收通知为任务执行人
            receiveExecutor();
            // 设置接收需求请求参数
            setCompleteQuery();
            // 发送通知
            useToast(person, info);
            return;
        }
        // 拒绝需求
        info.text = `${completeRequirementDept}拒绝接收跨部门需求${requirementName}`;
        // 接收通知需求部门领导人
        receiveRequirementLeader();
        // 发送通知人为完成部门领导人
        sendByCompleteLeader();
        // 设置发起需求请求参数
        setRequireQuery();
        // 发送通知
        useToast(person, info);
    };

    // 交付需求
    const setDeliver = () => {
        // 发送通知人为任务执行人
        sendByExecutor();
        // 接收通知为需求人
        receiveDemander();
        // 设置发起需求请求参数
        setRequireQuery();
        // 发送通知
        useToast(person, info);
    };

    // 需求交付确认
    const handleConfirmDelivery = () => {
        // 确认进行中不发送
        if (requirementDeliveryConfirmation === '进行中') return;
        // 交付需求确认
        if (requirementDeliveryConfirmation === '确认') {
            info.text = `${(store.state as any).user.user.nickName}确认跨部门${requirementName}需求完成`;
            // 交付需求退回
        } else if (requirementDeliveryConfirmation === '退回') {
            info.text = `${(store.state as any).user.user.nickName}退回跨部门${requirementName}需求`;
        }
        // 发送通知为需求人
        sendByDemander();
        // 接收通知为执行人
        receiveExecutor();
        // 设置发起需求请求参数
        setRequireQuery();
        // 发送通知
        useToast(person, info);
    };

    let text = '';
    switch (type) {
        // 审核请求
        case "requirementReview":
            text = `${demander}提出跨部门需求${requirementName}请审核`;
            info.text = text;
            setDemand();
            break;
        // 审核请求
        case "insert":
            text = `${demander}提出跨部门需求${requirementName}请审核`;
            info.text = text;
            setDemand();
            break;
        case "examine":
            text = `${demanderDept}提出跨部门需求${requirementName}请查收`;
            info.text = text;
            setExamine();
            break;
        case "update":
            text = `${demander}修改跨部门需求${requirementName}`;
            info.text = text;
            handleUpdate();
            break;
        case "receive":
            handleRecive();
            break;
        case "deliver":
            text = `${executor}交付跨部门需求${requirementName}`;
            info.text = text;
            setDeliver();
            break;
        case 'deliveryconfirmation':
            handleConfirmDelivery();
            break;
        case 'changeExcutor':
            setExcutor();
            break;
        default:
            break;
    }
};